"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// import { backgroundColor } from 'echarts/lib/theme/dark';
var _default = exports.default = {
  name: 'home_group',
  cname: '拼团',
  icon: 't-icon-zujian-pintuan',
  configName: 'c_home_group',
  type: 1,
  // 0 基础组件 1 营销组件 2工具组件
  defaultName: 'group',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), (0, _vuex.mapGetters)(['mobileTheme'])), {}, {
    //容器样式
    //最外层盒子的样式
    boxStyle: function boxStyle() {
      return [{
        'border-radius': this.configObj.bgStyle.val ? this.configObj.bgStyle.val + 'px' : '0'
      }, {
        margin: 0 + ' ' + this.configObj.lrConfig.val + 'px' + ' ' + 0
      }];
    },
    headerBgStyle: function headerBgStyle() {
      return [{
        background: "linear-gradient(to right,".concat(this.configObj.bgColor.color[0].item, ", ").concat(this.configObj.bgColor.color[1].item, ")")
      }];
    },
    //边距
    boxPadding: function boxPadding() {
      return [{
        padding: this.configObj.upConfig.val + 'px' + ' ' + '0px' + ' ' + this.configObj.downConfig.val + 'px'
      }, {
        margin: this.configObj.mbConfig.val + 'px' + ' ' + 0 + ' ' + 0
      }];
    },
    //背景颜色
    boxBgStyle: function boxBgStyle() {
      return [{
        gap: "".concat(this.configObj.contentConfig.val, "px")
      }, {
        background: "linear-gradient(to right,".concat(this.configObj.contentBgColor.color[0].item, ", ").concat(this.configObj.contentBgColor.color[1].item, ")")
      }];
    },
    //标题颜色
    titleColor: function titleColor() {
      return {
        color: this.configObj.titleColor.color[0].item
      };
    },
    //分割线颜色
    lineColor: function lineColor() {
      return {
        border: "0.5px solid ".concat(this.configObj.lineColor.color[0].item)
      };
    },
    //头部按钮颜色
    headerBtnColor: function headerBtnColor() {
      return {
        color: this.configObj.headerBtnColor.color[0].item
      };
    },
    //商品名称颜色
    nameColor: function nameColor() {
      return {
        color: this.configObj.nameColor.color[0].item
      };
    },
    //商品原价颜色
    originalColor: function originalColor() {
      return {
        color: this.configObj.originalColor.color[0].item
      };
    },
    //拼团价格颜色
    priceColor: function priceColor() {
      return {
        color: this.themeStyle ? this.configObj.priceColor.color[0].item : this.themeColor
      };
    },
    //标签颜色
    groupTitleColor: function groupTitleColor() {
      return {
        backgroundColor: this.themeStyle ? this.configObj.groupTitleColor.color[0].item : this.themeColor
      };
    },
    //已拼颜色
    groupTitleFontColor: function groupTitleFontColor() {
      return [{
        color: this.themeStyle ? this.configObj.groupTitleColor.color[0].item : this.themeColor
      }];
    },
    //按钮颜色
    btnColor: function btnColor() {
      return [{
        background: "linear-gradient(to right,".concat(this.themeStyle ? this.configObj.btnColor.color[0].item : '#FF7931', ", ").concat(this.themeStyle ? this.configObj.btnColor.color[1].item : this.themeColor, ")")
      }, {
        color: this.configObj.btnFontColor.color[0].item
      }];
    },
    //图片圆角
    contentStyle: function contentStyle() {
      return {
        'border-radius': this.configObj.contentStyle.val ? this.configObj.contentStyle.val + 'px' : '0'
      };
    },
    //样式一内容边距
    contentConfig: function contentConfig() {
      return {
        'margin-top': this.configObj.contentConfig.val + 'px'
      };
    },
    //背景图片
    bgImgStyle: function bgImgStyle() {
      return {
        'background-image': "url(".concat(this.bgImgUrl, ")")
      };
    },
    //标题文字格式
    headerTitleConfig: function headerTitleConfig() {
      return [{
        'font-weight': this.headerTitleStyle == 0 ? 600 : ''
      }, {
        'font-style': this.headerTitleStyle == 2 ? 'italic' : 'normal'
      }, {
        color: this.configObj.headerTitleColor.color[0].item
      }];
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal, oVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    },
    listStyle: function listStyle(nVal, oVal) {
      if (this.configObj.themeStyleConfig.tabVal == 1) {
        if (nVal == 2 || nVal == 3) {
          this.configObj.groupBtnConfig.isShow = 0;
          this.configObj.btnColor.isShow = 0;
          this.configObj.btnFontColor.isShow = 0;
        } else {
          this.configObj.groupBtnConfig.isShow = 1;
          this.configObj.btnColor.isShow = 1;
          this.configObj.btnFontColor.isShow = 1;
        }
      }
    },
    selectStyle: function selectStyle(nVal, oVal) {
      if (nVal == 0) {
        this.configObj.logoConfig.isShow = 1;
        this.configObj.titleConfig.isShow = 0;
        this.configObj.headerTitleStyle.isShow = 0;
        this.configObj.headerTitleColor.isShow = 0;
      } else {
        this.configObj.logoConfig.isShow = 0;
        this.configObj.titleConfig.isShow = 1;
        this.configObj.headerTitleStyle.isShow = 1;
        this.configObj.headerTitleColor.isShow = 1;
      }
    },
    selectBgImg: function selectBgImg(nVal, oVal) {
      if (nVal == 0) {
        this.configObj.bgImg.isShow = 1;
        this.configObj.bgColor.isShow = 0;
      } else {
        this.configObj.bgImg.isShow = 0;
        this.configObj.bgColor.isShow = 1;
      }
    },
    themeStyle: {
      handler: function handler(nVal, oVal) {
        if (this.listStyle == 2 || this.listStyle == 3) {
          this.configObj.btnColor.isShow = 0;
          this.configObj.priceColor.isShow = this.configObj.themeStyleConfig.tabVal;
          this.configObj.groupTitleColor.isShow = this.configObj.themeStyleConfig.tabVal;
        } else {
          this.configObj.priceColor.isShow = this.configObj.themeStyleConfig.tabVal;
          this.configObj.groupTitleColor.isShow = this.configObj.themeStyleConfig.tabVal;
          this.configObj.btnColor.isShow = this.configObj.themeStyleConfig.tabVal;
        }
      },
      deep: true
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        name: 'group',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '拼团'
        },
        tabConfig: {
          title: '展示样式',
          tabTitle: '布局设置',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '样式一',
            icon: 'icon-yangshier'
          }, {
            val: '样式二',
            icon: 'icon-yangshisan'
          }, {
            val: '样式三',
            icon: 'icon-dianpujie-yangshiyi'
          }, {
            val: '样式四',
            icon: 'icon-ic_layout4'
          }]
        },
        selectStyle: {
          cname: 'selectStyle',
          title: '标题类型',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '图片'
          }, {
            val: '文字'
          }]
        },
        logoConfig: {
          isShow: 1,
          tabTitle: '头部设置',
          title: '标题图片',
          tips: '建议：154px*32px',
          url: localStorage.getItem('mediaDomain') + '/crmebimage/presets/groupTitle.png'
        },
        selectBgImg: {
          cname: 'selectBgImg',
          title: '选择风格',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '背景图片'
          }, {
            val: '背景色'
          }]
        },
        bgImg: {
          isShow: 1,
          title: '背景图片',
          tips: '建议：710px*96px',
          url: localStorage.getItem('mediaDomain') + '/crmebimage/presets/groupBg.png'
        },
        titleConfig: {
          title: '标题文字',
          val: '超值拼团',
          place: '请输入标题',
          isShow: 1,
          max: 6
        },
        //显示内容
        typeConfig: {
          tabTitle: '显示内容',
          name: 'rowsNum',
          title: '展示信息',
          activeValue: [0, 1, 2, 3],
          list: [{
            val: '商品名称'
          }, {
            val: '活动标签'
          }, {
            val: '商品价格'
          }, {
            val: '商品原价'
          }]
        },
        groupBtnConfig: {
          cname: 'groupBtnConfig',
          title: '拼团按钮',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '显示'
          }, {
            val: '隐藏'
          }]
        },
        // 背景颜色
        bgColor: {
          tabTitle: '头部设置',
          title: '背景颜色',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }]
        },
        // 内容背景颜色
        contentBgColor: {
          tabTitle: '颜色设置',
          title: '内容背景',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }]
        },
        headerTitleStyle: {
          cname: 'headerTitleStyle',
          title: '标题文字',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '加粗'
          }, {
            val: '正常'
          }, {
            val: '倾斜'
          }]
        },
        headerTitleColor: {
          title: '标题颜色',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        lineColor: {
          title: '分割线颜色',
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        titleColor: {
          title: '提示文字颜色',
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        headerBtnColor: {
          title: '头部按钮颜色',
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        nameColor: {
          tabTitle: '商品设置',
          title: '商品名称颜色',
          color: [{
            item: '#000000'
          }],
          default: [{
            item: '#000000'
          }]
        },
        originalColor: {
          title: '商品原价颜色',
          color: [{
            item: '#999999'
          }],
          default: [{
            item: '#999999'
          }]
        },
        //色调
        themeStyleConfig: {
          title: '色调',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '跟随主题风格'
          }, {
            val: '自定义'
          }]
        },
        priceColor: {
          title: '拼团价格颜色',
          isShow: 0,
          color: [{
            item: '#E93323'
          }],
          default: [{
            item: '#E93323'
          }]
        },
        groupTitleColor: {
          title: '标签颜色',
          isShow: 0,
          color: [{
            item: 'rgba(233, 51, 35, 1)'
          }],
          default: [{
            item: 'rgba(233, 51, 35, 1)'
          }]
        },
        btnColor: {
          title: '按钮颜色',
          isShow: 0,
          color: [{
            item: '#E93323'
          }, {
            item: '#E93323'
          }],
          default: [{
            item: '#E93323'
          }, {
            item: '#E93323'
          }]
        },
        btnFontColor: {
          title: '按钮文字颜色',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        bgStyle: {
          tabTitle: '圆角设置',
          title: '背景圆角',
          name: 'bgStyle',
          val: 7,
          min: 0,
          max: 30
        },
        contentStyle: {
          title: '图片圆角',
          name: 'contentStyle',
          val: 5,
          min: 0,
          max: 30
        },
        // 上间距
        upConfig: {
          tabTitle: '边距设置',
          title: '上边距',
          val: 10,
          min: 0,
          max: 100
        },
        // 下间距
        downConfig: {
          title: '下边距',
          val: 10,
          min: 0
        },
        // 左右间距
        lrConfig: {
          title: '左右边距',
          val: 12,
          min: 0,
          max: 15
        },
        mbConfig: {
          title: '页面间距',
          val: 0,
          min: 0
        },
        contentConfig: {
          title: '内容间距',
          val: 5,
          min: 0,
          max: 20
        }
      },
      listStyle: 0,
      configObj: null,
      logoUrl: null,
      typeShow: [0, 1, 2, 3],
      groupBtnShow: true,
      selectStyle: '',
      titleConfig: '',
      selectBgImg: '',
      bgImgUrl: '',
      headerTitleStyle: 0,
      themeStyle: 0,
      themeColor: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.num) {
        var pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
        _this.setConfig(pageData);
      }
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      if (data) {
        this.configObj = data;
        this.listStyle = this.configObj.tabConfig.tabVal;
        this.logoUrl = this.configObj.logoConfig.url;
        this.typeShow = this.configObj.typeConfig.activeValue;
        this.groupBtnShow = this.configObj.groupBtnConfig.tabVal == 0 ? true : false;
        this.selectStyle = this.configObj.selectStyle.tabVal;
        this.titleConfig = this.configObj.titleConfig.val;
        this.selectBgImg = this.configObj.selectBgImg.tabVal;
        this.bgImgUrl = this.configObj.bgImg.url;
        this.headerTitleStyle = this.configObj.headerTitleStyle.tabVal;
        this.themeStyle = data.themeStyleConfig.tabVal;
        this.themeColor = this.$options.filters.filterTheme(this.mobileTheme - 1);
      }
    }
  }
};